module.exports = __webpack_public_path__ + "img/newpage-bg.7dad561f.jpg";